<template>
  <div class="sai-tag-list">
    <div class="sai-tag-list__content">
      <div class="title">
        <div class="text">
          {{ tagTitle }}
        </div>
      </div>
      <div class="tags">
        <a
          class="tag"
          v-for="(candidate, index) in filteredCandidateTags"
          v-bind:key="index"
          v-if="index < 6 && candidate.tag"
          @click.prevent="selectTag(candidate)"
        >
          <span class="content">
            {{ convertTagText(candidate) }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component';
import TagListMixin from '@/mixins/TagListMixin';
import { eventBus } from '@/eventBus';
import Const from '../const/index';

@Component({})
export default class TagList extends mixins(TagListMixin) {
  get tagTitle() {
    return this.inputEmpty ? Const.TAG_POPULAR_TITLE : Const.TAG_RECOMMEND_TITLE;
  }
  async selectTag(candidate) {
    if (this.$store.state.user.isIphone && this.$store.state.onIME) {
      eventBus.$emit('toggleIme', false);
      return;
    }
    const displayText = this.convertTagText(candidate);
    const selectedTag = Object.assign(candidate.tag, { displayText });
    const exTags = this.$store.getters['tagSearch/selectedKeywordTags'];
    const exText = this.$store.state.tagSearch.searchText;

    await this.$emit('onSelectTag', selectedTag);

    if (!this.$store.state.tagSearch.show) {
      await this.$store.commit('tagSearch/setShow', true);
    }

    if (!this.$store.state.user.isIphone) {
      await eventBus.$emit('selectNextTag');
    }

    if (this.$store.state.ticket.resetFlag) {
      eventBus.$emit('resetTicket');
      return;
    }

    const newTicket = await this.updateTicket(selectedTag, exTags, exText);
    await this.$ticket.setData(newTicket);
    this.$ticket.post();
  }
  async updateTicket(tag, exTags) {
    const startTime =
      this.$store.state.ticket.startTime || String(new Date().getTime());
    this.$store.commit('ticket/setStartTime', startTime);
    const categoryTags = this.$store.getters['tagSearch/selectedCategoryTags'];

    let historyActions = [];
    if (exTags.length === 0 && categoryTags.length === 0) {
      historyActions = [
        { type: 'tag', value: 'initial' },
        { type: '', value: 'search' },
      ];
    } else if (exTags.length === 0 && categoryTags.length > 0) {
      historyActions = [{ type: 'tag', value: 'initial' }];
    } else if (exTags.length > 0 && categoryTags.length === 0) {
      historyActions = [{ type: '', value: 'search' }];
    }
    if (historyActions.length > 0) {
      await this.$store.dispatch(
        'ticket/addHistoryActionFaqChannels',
        historyActions
      );
    }
    const keywordTags = this.$store.getters['tagSearch/selectedKeywordTags'];
    const tagActiveSet =
      keywordTags.length === 0
        ? []
        : keywordTags.map(t => {
            const v = { id: t.id, text: t.text };
            if (t.displayText) {
              v.label = t.displayText;
            }
            return v;
          });
    if (
      keywordTags.length > 0 &&
      this.$store.state.ticket.tagUsedSet.length === 0
    ) {
      this.$store.commit('ticket/setTagUsedSet', tagActiveSet);
    } else {
      let tagUsedSet = { id: tag.id, text: tag.text };
      if (tag.displayText) {
        tagUsedSet.label = tag.displayText;
      }
      this.$store.commit('ticket/addTagUsedSet', tagUsedSet);
    }
    const query = this.$store.state.tagSearch.searchText;
    if (query && this.$store.state.ticket.historyQuery.length === 0) {
      this.$store.commit('ticket/setHistoryQuery', [query]);
    }
    return this.generateTicket(startTime, query, tagActiveSet);
  }
}
</script>

<style lang="scss" scoped>
@import '../style/settings';
@import '../style/setting/variable';

.sai-tag-list {
  padding: 7px 3px 0 3px;
  min-height: 78px;

  .mobile & {
    display: flex;
    align-items: baseline;
    padding: 8px 0 0 0;
  }

  &__content {
    .title {
      padding: 6px 0;
      .text {
        color: #757575;
        font-size: 13px;
        .mobile & {
          font-size: 12px;
        }
      }
    }
  }

  .tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .tag {
      display: inline-block !important;
      background-color: #333 !important;
      color: #fff !important;
      border-radius: 3px !important;
      padding: 4px 9px 4px 9px !important;
      margin: 0 8px 8px 0 !important;
      cursor: pointer !important;
      pointer-events: auto !important;
      -webkit-tap-highlight-color: transparent !important;
      font-family: $subFontFamily;
      line-height: 22px;

      &:hover {
        background: #757575 !important;
        .mobile & {
          background-color: #333 !important;
        }
      }

      .content {
        font-size: 14px;
        font-weight: 600;
        display: inline-block;
        .mobile & {
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// products/390/components/TagList.vue